import { Controller } from "@hotwired/stimulus"

// Simulates the checkout experience in demo mode.
// Shows a brief processing state before redirecting to the success page.
export default class extends Controller {
  static targets = ["submitButton", "buttonText", "buttonSpinner"]
  static values = { successUrl: String }

  submit() {
    // Show processing state
    this.submitButtonTarget.disabled = true
    this.buttonTextTarget.classList.add("hidden")
    this.buttonSpinnerTarget.classList.remove("hidden")

    // Simulate processing delay, then redirect
    setTimeout(() => {
      window.location.href = this.successUrlValue
    }, 1500)
  }
}
